import React from 'react';
import { Link } from 'gatsby';
import { SearchResult } from '../../../interfaces/Article.interface';
import Loader from '../../atoms/loader/Loader';
import './SearchResultsBox.scss';
import { sendDataLayer } from '../../../utils/functions';

interface Props {
    results: SearchResult[];
    showLoader: boolean;
    query: string;
}

const SearchResultsBox = ({ results, showLoader, query }: Props) => {
    return (
        <div className="m-search-results-box">
            {showLoader ? (
                <Loader />
            ) : results.length > 0 ? (
                <>
                    <h3>Resultados de búsqueda</h3>
                    <hr />

                    <ul>
                        {results.map((result) => (
                            <li
                                key={result.id}
                                onClick={() =>
                                    sendDataLayer({
                                        event: 'cfm_click_result_elastic',
                                        keyword: query,
                                        url: result.slug,
                                        index: result.origin,
                                    })
                                }
                            >
                                <Link
                                    to={result.slug}
                                    className={`result-item gtmBuscadorHomeprediccion${result.title.replace(
                                        / /g,
                                        ''
                                    )}`}
                                    target="_blank"
                                    title={result.title}
                                >
                                    {result.origin && (
                                        <span className="m-search-results-box__origin">
                                            {result.origin}{' '}
                                            {result.category &&
                                                `/ ${result.category}`}
                                        </span>
                                    )}
                                    <h4
                                        className={`gtmBuscadorHomeprediccion${result.title.replace(
                                            / /g,
                                            ''
                                        )}`}
                                    >
                                        {result.title}
                                    </h4>
                                    <p
                                        className={`m-search-results-box__desc gtmBuscadorHomeprediccion${result.title.replace(
                                            / /g,
                                            ''
                                        )}`}
                                    >
                                        {result.description}
                                    </p>
                                </Link>
                            </li>
                        ))}
                    </ul>
                </>
            ) : (
                <h3>Sin resultados de búsqueda</h3>
            )}
        </div>
    );
};

export default SearchResultsBox;
